// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const volcarona: PokeData = {
  "id": 637,
  "name": "volcarona",
  "height": 16,
  "weight": 460,
  "base_experience": 248,
  "types": [
    PokeType.BUG,
    PokeType.FIRE
  ],
  "api_moves": [
    "gust",
    "whirlwind",
    "take-down",
    "thrash",
    "double-edge",
    "ember",
    "absorb",
    "string-shot",
    "fire-spin",
    "screech",
    "fire-blast",
    "amnesia",
    "leech-life",
    "flame-wheel",
    "heat-wave",
    "silver-wind",
    "flare-blitz",
    "bug-buzz",
    "bug-bite",
    "rage-powder",
    "quiver-dance",
    "flame-charge",
    "struggle-bug",
    "hurricane",
    "fiery-dance"
  ],
  "moves": [
    "gust",
    "ember",
    "string-shot",
    "fire-spin",
    "flare-blitz",
    "bug-buzz",
    "bug-bite",
    "hurricane",
    "fire-ball",
    "heal-order",
    "blaze-kick",
    "lunge",
    "pin-missile"
  ],
  "evolution_chain": {
    "id": 324,
    "item": null,
    "species": [
      {
        "name": "larvesta",
        "order": 637,
        "types": [
          PokeType.BUG,
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "volcarona",
        "order": 638,
        "types": [
          PokeType.BUG,
          PokeType.FIRE
        ],
        "evolves_from_species_id": 636,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 59,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 106,
    "speed": 125,
    "ability_power": 169
  },
  "stat_changes": [],
  "catch_rate": 15,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
